import { render } from "./SchedulerMailAccordion.vue?vue&type=template&id=1e6763c6&scoped=true&ts=true"
import script from "./SchedulerMailAccordion.vue?vue&type=script&lang=ts"
export * from "./SchedulerMailAccordion.vue?vue&type=script&lang=ts"

import "./SchedulerMailAccordion.vue?vue&type=style&index=0&id=1e6763c6&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e6763c6"]])

export default __exports__